import React from 'react';
import FadeIn from '../components/ui/FadeIn';
import Button from '../components/ui/Button';

const Contact = () => {
  return (
    <div className="pt-40 pb-40 bg-brand-ivory">
      <div className="container mx-auto px-6">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-24">
          <FadeIn>
            <h1 className="text-6xl md:text-8xl font-heading mb-8">Let’s create <br /><span className="serif-italic text-brand-orange">intentional.</span></h1>
            <p className="text-xl opacity-70 mb-16 leading-relaxed">
              Whether you’re booking a session or exploring an idea, share the details and we’ll take it from there.
            </p>
            
            <div className="space-y-12">
              <div className="group">
                <h4 className="text-[10px] font-bold tracking-widest uppercase text-brand-orange mb-4">Location</h4>
                <p className="text-xl leading-relaxed">
                  Unit H38, New Horizon Mall<br />
                  260300 Writing Creek Cres<br />
                  Balzac, AB T4A 0X8
                </p>
              </div>
              <div>
                <h4 className="text-[10px] font-bold tracking-widest uppercase text-brand-orange mb-4">Inquiries</h4>
                <a href="mailto:connect@lbbrandhaus.com" className="text-2xl font-serif italic hover:text-brand-orange transition-colors">connect@lbbrandhaus.com</a>
                <p className="mt-2 text-xl">368-599-0012</p>
              </div>
            </div>
          </FadeIn>

          <FadeIn direction="left" className="bg-white p-12 md:p-20 rounded-[3rem] shadow-sm flex flex-col justify-center">
            <h3 className="text-3xl font-heading mb-8">Custom Request</h3>
            <p className="text-lg opacity-70 mb-12">
              Don’t see what you’re looking for? From maternity shoots to events and custom content sessions, we’re always open to creating something that fits your vision.
            </p>
            <Button href="https://forms.gle/Q42rAtfxkDFAVoCLA" variant="primary">Send a Request</Button>
          </FadeIn>
        </div>
      </div>
    </div>
  );
};

export default Contact;